import PcCRUDBoilerPlate from "../../CRUDBoilerPlate/PcCRUDBoilerPlate";

function PcNSTTsCRUD({

    // parentChild props
    parentDBField,

    // common props
    api, screenTopicSingular, screenTopicPlural,
    
    // crud header props
    showTotalInHeading,
    
    // crud props
    allowCreate, allowUpdate, allowDelete,
    
    // field props
    //text props
    textDBField, textName,

    // text select props
    textSelectField, textSelectOptions, textSelectName,
    
    // select props
    selectApi, selectType, selectDBField, selectName

}) {

  return (
    <PcCRUDBoilerPlate

        // parentChild props
        parentDBField={parentDBField}
        
        // common props
        api={api}
        screenTopicSingular={screenTopicSingular}
        screenTopicPlural={screenTopicPlural}
        
        // crud header props
        showTotalInHeading={showTotalInHeading}
        
        // crud props
        allowCreate={allowCreate}
        allowUpdate={allowUpdate}
        allowDelete={allowDelete}
        
        // field props
        hasName

        //text props
        hasText
        textDBField={textDBField}
        textName={textName}
        
        // select props
        hasSelect
        selectApi={selectApi}
        selectType={selectType}
        selectDBField={selectDBField}
        selectName={selectName}

        // TextSelect props
        hasTextSelect
        textSelectField={textSelectField}
        textSelectOptions={textSelectOptions}
        textSelectName={textSelectName}
    />
  )
}

export default PcNSTTsCRUD